import { Component, ComponentFactoryResolver, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { ActivatedRoute, Params } from '@angular/router';
import { GeneralService } from 'src/app/core/services/general/general.service';
import { CabeceraComponent } from 'src/app/shared/widgets/cabecera/cabecera.component';
import { CardsGeneralDosComponent } from 'src/app/shared/widgets/cards-general-dos/cards-general-dos.component';
import { CardsGeneralComponent } from 'src/app/shared/widgets/cards-general/cards-general.component';
import { CarrouselGeneralComponent } from 'src/app/shared/widgets/carrousel-general/carrousel-general.component';
import { CustomDiaryGeneralComponent } from 'src/app/shared/widgets/custom-diary-general/custom-diary-general.component';
import { CustomStatsGeneralComponent } from 'src/app/shared/widgets/custom-stats-general/custom-stats-general.component';
import { FormContactoComponent } from 'src/app/shared/widgets/form-contacto/form-contacto.component';

import { HeaderSectionComponent } from 'src/app/shared/widgets/header-section/header-section.component';
import { ListaDeLinksComponent } from 'src/app/shared/widgets/lista-de-links/lista-de-links.component';
import { PostComponent } from 'src/app/shared/widgets/post/post.component';
import { PrimeraFotoDestacadaComponent } from 'src/app/shared/widgets/primera-foto-destacada/primera-foto-destacada.component';
import { TextItemGeneralComponent } from 'src/app/shared/widgets/text-item-general/text-item-general.component';
import { VideoMasFormularioComponent } from 'src/app/shared/widgets/video-mas-formulario/video-mas-formulario.component';
import { ListDesplegableComponent } from '../../components/list-desplegable/list-desplegable.component';
import { FacultadPortadaComponent } from 'src/app/shared/widgets/facultad-portada/facultad-portada.component';
import { FacultadInformacionInicialComponent } from 'src/app/shared/widgets/facultad-informacion-inicial/facultad-informacion-inicial.component';
import { FacultadOfertaAcademicaComponent } from 'src/app/shared/widgets/facultad-oferta-academica/facultad-oferta-academica.component';
import { BannerFacultdadComponent } from 'src/app/shared/components/banner-facultdad/banner-facultdad.component';
import { DesplegablesFacultdadComponent } from 'src/app/shared/components/desplegables-facultdad/desplegables-facultdad.component';
import { FacultdadDatosExtrasComponent } from 'src/app/shared/components/facultdad-datos-extras/facultdad-datos-extras.component';
import { FacultdadNoticiasComponent } from 'src/app/shared/components/facultdad-noticias/facultdad-noticias.component';
import { FacultdadPublicidadComponent } from 'src/app/shared/components/facultdad-publicidad/facultdad-publicidad.component';
import { PreguntasFrecuentesFacultdadComponent } from 'src/app/shared/components/preguntas-frecuentes-facultdad/preguntas-frecuentes-facultdad.component';

@Component({
  selector: 'app-facultades',
  templateUrl: './facultades.component.html',
  styleUrls: ['./facultades.component.scss'],
})
export class FacultadesComponent implements OnInit {
  language: string;
  venue: string;
  notices: any[];
  datos: any;
  article: any;
  postsRelations: any;
  carrer: string;
  carrerType: string;
  carrerInfo: any;
  fare: string;
  type: number = 1;
  countFamily: number = 1;
  isNotice: boolean = false;
  isSinglePage: boolean = false;
  count = 0;
  data: any;
  arrayRowsSize: any;
  arrayRows: any[] = [];
  itemCarrouselHeader: any[] = [];
  path: string;
  pathMob: string;
  innerHTML = '';
  textITemExiste: boolean = false
  @ViewChild('componenteDinamico1', { read: ViewContainerRef }) viewContainerRef1: ViewContainerRef;
  @ViewChild('componenteDinamico2', { read: ViewContainerRef }) viewContainerRef2: ViewContainerRef;
  @ViewChild('componenteDinamico3', { read: ViewContainerRef }) viewContainerRef3: ViewContainerRef;
  @ViewChild('componenteDinamico4', { read: ViewContainerRef }) viewContainerRef4: ViewContainerRef;
  @ViewChild('componenteDinamico5', { read: ViewContainerRef }) viewContainerRef5: ViewContainerRef;
  @ViewChild('componenteDinamico6', { read: ViewContainerRef }) viewContainerRef6: ViewContainerRef;
  @ViewChild('componenteDinamico7', { read: ViewContainerRef }) viewContainerRef7: ViewContainerRef;
  @ViewChild('componenteDinamico8', { read: ViewContainerRef }) viewContainerRef8: ViewContainerRef;
  @ViewChild('componenteDinamico9', { read: ViewContainerRef }) viewContainerRef9: ViewContainerRef;
  @ViewChild('componenteDinamico10', { read: ViewContainerRef }) viewContainerRef10: ViewContainerRef;
  @ViewChild('componenteDinamico11', { read: ViewContainerRef }) viewContainerRef11: ViewContainerRef;
  @ViewChild('componenteDinamico12', { read: ViewContainerRef }) viewContainerRef12: ViewContainerRef;
  @ViewChild('componenteDinamico13', { read: ViewContainerRef }) viewContainerRef13: ViewContainerRef;
  @ViewChild('componenteDinamico14', { read: ViewContainerRef }) viewContainerRef14: ViewContainerRef;
  @ViewChild('componenteDinamico15', { read: ViewContainerRef }) viewContainerRef15: ViewContainerRef;
  @ViewChild('componenteDinamico16', { read: ViewContainerRef }) viewContainerRef16: ViewContainerRef;
  @ViewChild('componenteDinamico17', { read: ViewContainerRef }) viewContainerRef17: ViewContainerRef;
  @ViewChild('componenteDinamico18', { read: ViewContainerRef }) viewContainerRef18: ViewContainerRef;
  @ViewChild('componenteDinamico19', { read: ViewContainerRef }) viewContainerRef19: ViewContainerRef;
  @ViewChild('componenteDinamico20', { read: ViewContainerRef }) viewContainerRef20: ViewContainerRef;
  viewContainerRefs: any[] = []
  constructor(private componentFactoryResolver: ComponentFactoryResolver, public router: ActivatedRoute, public venueService: GeneralService, public title: Title, public meta: Meta) {
    this.router.params.forEach((params: Params) => {
      this.venue = params['venue'];
    });

    let venueText = (this.venue.charAt(0).toUpperCase() + this.venue.slice(1)).replace(/-/g, " ");


    this.title.setTitle('UCA - ' + venueText);
    this.meta.addTag({ property: 'og:title', content: 'UCA - ' + venueText }, true);
    this.meta.addTag({ property: 'og:description', content: '' }, true);
  }

  ngOnInit(): void {


    this.router.params.forEach((params: Params) => {
      this.language = params['language'];
    });

  }



  ngAfterViewInit() {
    this.venueService.getPages(this.venue, this.language).subscribe(data => {
      this.data = data.data[0];
      this.arrayRowsSize = this.data['pagesLength'];
      for (let i = 1; i < this.arrayRowsSize + 1; i++) {
        if (this.data[i][0]['status']) {
          this.arrayRows.push(i);
          this.loadPageAt(i, this.data[i][0].entityType);
        }
      }
    })
  }


  async loadPageAt(index: number, entityType: string) {
    const pageData = this.data[index];

    if (pageData.length > 1) {
      this.venueService.getVenueEntity(pageData[0]["route"], this.language).subscribe(data1 => {
        this.renderComponent(index, pageData[0], 8, data1);

        this.venueService.getVenueEntity(pageData[1]['route'], '&locale=' + this.language).subscribe(data2 => {
          this.renderComponent(index, pageData[1], 4, data2);
        });
      });
    } else {
      this.venueService.getVenueEntity(pageData[0]['route'], '&locale=' + this.language).subscribe(data1 => {
        this.renderComponent(index, pageData[0], 12, data1 );
      });
    }

  }

  renderComponent(index: number, element: any, width: number, rawData: any, background?: string,elementIdParam?: any) {
    let info = rawData.data[0];
    const elementId = elementIdParam || element.id ;
    if (info.career) {
      let factory = this.componentFactoryResolver.resolveComponentFactory(CarrouselGeneralComponent);
      let ref = this.viewContainerRefA(index).createComponent(factory);
      ref.instance.data = info.career;
      ref.instance.title = "Carreras";
      ref.location.nativeElement.classList.add('col-lg-' + width);
      ref.changeDetectorRef.detectChanges();
      return; 
    }

    let componentType = element.entityType;
    if (componentType === 'CustomSocialNetwork') componentType = 'Cards';
    if (element.typeDisplay) componentType = element.typeDisplay;

    if (componentType === 'EntityList') {
      info.entityList.forEach((subElement: any) => {
        this.renderComponent(index, subElement, width, rawData, subElement.background, element.id);
      });
      return; 
    }
    switch (componentType) {
      case 'NewCover': {
        let factory = this.componentFactoryResolver.resolveComponentFactory(FacultadPortadaComponent);
        let ref2 = this.viewContainerRefA(index).createComponent(factory);
        ref2.location.nativeElement.classList.add('col-lg-' + width);
        ref2.instance.data = info;
        if (elementId) ref2.location.nativeElement.id = componentType + elementId;
        ref2.instance.language = this.language;
        ref2.changeDetectorRef.detectChanges();
        break;
      }
      case 'OurVenue': {
        let factory = this.componentFactoryResolver.resolveComponentFactory(FacultadInformacionInicialComponent);
        let ref2 = this.viewContainerRefA(index).createComponent(factory);
        ref2.location.nativeElement.classList.add('col-lg-' + width);
        ref2.instance.info = info;
        if (elementId) ref2.location.nativeElement.id = componentType + elementId;
        ref2.instance.language = this.language;
        ref2.changeDetectorRef.detectChanges();
        break;
      }      
      case 'AcademicOffer': {
        let factory = this.componentFactoryResolver.resolveComponentFactory(FacultadOfertaAcademicaComponent);
        let ref2 = this.viewContainerRefA(index).createComponent(factory);
        ref2.location.nativeElement.classList.add('col-lg-' + width);
        ref2.instance.info = info;
        if (elementId) ref2.location.nativeElement.id = componentType + elementId;
        ref2.instance.language = this.language;
        ref2.changeDetectorRef.detectChanges();
        break;
      }

      case 'Banner': {
        let factory = this.componentFactoryResolver.resolveComponentFactory(BannerFacultdadComponent);
        let ref2 = this.viewContainerRefA(index).createComponent(factory);
        ref2.location.nativeElement.classList.add('col-lg-' + width);
        ref2.instance.info = info;
        if (elementId) ref2.location.nativeElement.id = componentType + elementId;
        ref2.instance.language = this.language;
        ref2.changeDetectorRef.detectChanges();
        break;
      }
      case 'Accordion': {
        let factory = this.componentFactoryResolver.resolveComponentFactory(DesplegablesFacultdadComponent);
        let ref2 = this.viewContainerRefA(index).createComponent(factory);
        ref2.location.nativeElement.classList.add('col-lg-' + width);
        ref2.instance.info = info;
        if (elementId) ref2.location.nativeElement.id = componentType + elementId;
        ref2.instance.language = this.language;
        ref2.changeDetectorRef.detectChanges();
        break;
      }

      case 'SchoolInformation': {
        let factory = this.componentFactoryResolver.resolveComponentFactory(FacultdadDatosExtrasComponent);
        let ref2 = this.viewContainerRefA(index).createComponent(factory);
        ref2.location.nativeElement.classList.add('col-lg-' + width);
        ref2.instance.info = info;
        if (elementId) ref2.location.nativeElement.id = componentType + elementId;
        ref2.instance.language = this.language;
        ref2.changeDetectorRef.detectChanges();
        break;

      }
      
      case 'Advertising': {
        let factory = this.componentFactoryResolver.resolveComponentFactory(FacultdadPublicidadComponent);
        let ref2 = this.viewContainerRefA(index).createComponent(factory);
        ref2.location.nativeElement.classList.add('col-lg-' + width);
        ref2.instance.info = info;
        if (elementId) ref2.location.nativeElement.id = componentType + elementId;
        ref2.instance.language = this.language;
        ref2.changeDetectorRef.detectChanges();
        break;
        
      }
      case 'VenueFaq': {
        let factory = this.componentFactoryResolver.resolveComponentFactory(PreguntasFrecuentesFacultdadComponent);
        let ref2 = this.viewContainerRefA(index).createComponent(factory);
        ref2.location.nativeElement.classList.add(`col-lg-${width}`, 'px-0');
        ref2.instance.info = info;
        if (elementId) ref2.location.nativeElement.id = componentType + elementId;
        ref2.instance.language = this.language;
        ref2.changeDetectorRef.detectChanges();
        break;

      }

      case 'HeaderSection': {
        let factory = this.componentFactoryResolver.resolveComponentFactory(HeaderSectionComponent);
        let ref2 = this.viewContainerRefA(index).createComponent(factory);
        ref2.location.nativeElement.classList.add('col-lg-' + width);
        ref2.instance.title = info.headerSection.title;
        ref2.instance.pathMob = info.headerSection.pathMobile;
        ref2.instance.path = info.headerSection.path;
        if (elementId) ref2.location.nativeElement.id = componentType + elementId;
        ref2.instance.language = this.language;
        ref2.instance.itemCarrouselHeader = info.headerSection.headerSectionItem.slice(0, 6);
        ref2.changeDetectorRef.detectChanges();
        break;
      }

      case 'Primera foto destacada': {
        let factory = this.componentFactoryResolver.resolveComponentFactory(PrimeraFotoDestacadaComponent);
        let ref = this.viewContainerRefA(index).createComponent(factory);
        ref.location.nativeElement.classList.add('col-lg-' + width);
        if (elementId) ref.location.nativeElement.id = componentType + elementId;
        ref.instance.data = info['entityList'][0].entity;
        ref.instance.title = info['entityList'][0].title;
        ref.changeDetectorRef.detectChanges();
        break;
      }

      case 'Simple': {
        let factory = this.componentFactoryResolver.resolveComponentFactory(CardsGeneralComponent);
        let ref = this.viewContainerRefA(index).createComponent(factory);
        if (width === 8) ref.instance.numberCards = 3;
        if (elementId) ref.location.nativeElement.id = componentType + elementId;
        ref.instance.data = info.entityList[0].entity;
        ref.instance.title = info.entityList[0].title;
        ref.instance.background = background;
        ref.location.nativeElement.classList.add('col-lg-' + width);
        ref.changeDetectorRef.detectChanges();
        break;
      }

      case 'CustomPublication': {
        let factory = this.componentFactoryResolver.resolveComponentFactory(CarrouselGeneralComponent);
        let ref = this.viewContainerRefA(index).createComponent(factory);
        if (elementId) ref.location.nativeElement.id = componentType + elementId;
        ref.instance.data = info.publication;
        ref.instance.title = 'Publicaciones';
        ref.instance.background = background;
        ref.location.nativeElement.classList.add('col-lg-' + width);
        ref.changeDetectorRef.detectChanges();
        break;
      }

      case 'Noticias con resumen': {
        let factory = this.componentFactoryResolver.resolveComponentFactory(FacultdadNoticiasComponent);
        let ref2 = this.viewContainerRefA(index).createComponent(factory);
        ref2.location.nativeElement.classList.add('col-lg-' + width);
        ref2.instance.info = info.entityList[0];
        if (elementId) ref2.location.nativeElement.id = "EntityList" + elementId;
        ref2.instance.language = this.language;
        ref2.changeDetectorRef.detectChanges();
        break;
      }

      case 'Carrousel':
        if (info.entityList[0]?.entity) {
          let factory = this.componentFactoryResolver.resolveComponentFactory(CarrouselGeneralComponent);
          let ref = this.viewContainerRefA(index).createComponent(factory);
          ref.instance.data = info.entityList[0].entity;
          ref.instance.title = info.entityList[0].title;
          if (elementId) ref.location.nativeElement.id = componentType + elementId;

          ref.instance.background = background;
          ref.location.nativeElement.classList.add('col-lg-' + width);
          ref.changeDetectorRef.detectChanges();
        }
        break;

      case 'Lista desplegable':
        if (info.entityList[0]?.entity) {
          let factory = this.componentFactoryResolver.resolveComponentFactory(ListDesplegableComponent);
          let ref = this.viewContainerRefA(index).createComponent(factory);
          if (elementId) ref.location.nativeElement.id = componentType + elementId;

          ref.instance.items = info.entityList[0].entity;
          ref.instance.title = info.entityList[0].title;
          ref.location.nativeElement.classList.add('col-lg-' + width);
          ref.changeDetectorRef.detectChanges();
        }
        break;

      case 'Cards': {
        let factory = this.componentFactoryResolver.resolveComponentFactory(CardsGeneralDosComponent);
        let ref = this.viewContainerRefA(index).createComponent(factory);
        if (elementId) ref.location.nativeElement.id = componentType +  elementId;
        ref.instance.data = info.socialNetwork.socialNetworkItem;
        ref.instance.title = info.socialNetwork.title;
        ref.location.nativeElement.classList.add('col-lg-' + width);
        ref.changeDetectorRef.detectChanges();
        break;
      }

      case 'Lista de links':
        if (info.entityList[0]?.entity) {
          const factory = this.componentFactoryResolver.resolveComponentFactory(ListaDeLinksComponent);
          const ref = this.viewContainerRefA(index).createComponent(factory);
          if (elementId) ref.location.nativeElement.id = componentType + elementId;
          ref.instance.data = info.entityList[0].entity;
          ref.instance.title = info.entityList[0].title;

          ref.location.nativeElement.classList.add('col-lg-' + width);
          ref.instance.background = background;
          ref.changeDetectorRef.detectChanges();
        }
        break;

      case 'Video + Formulario (en ingles)':
      case 'Video + Formulario (en español)':
        if (info.entityList[0]?.linkCode) {
          const factory = this.componentFactoryResolver.resolveComponentFactory(VideoMasFormularioComponent);
          const ref = this.viewContainerRefA(index).createComponent(factory);
          if (elementId) ref.location.nativeElement.id = componentType + elementId;
          ref.instance.linkCode = info.entityList[0].linkCode;
          ref.location.nativeElement.classList.add('col-lg-' + width);
          ref.instance.title = info.entityList[0].title;
          ref.instance.background = background;
          ref.instance.idioma = componentType.includes('ingles') ? 'en' : 'es';
          ref.changeDetectorRef.detectChanges();
        }
        break;

      case 'TextItem': {
        const factory = this.componentFactoryResolver.resolveComponentFactory(TextItemGeneralComponent);
        const ref = this.viewContainerRefA(index).createComponent(factory);
        if (elementId) ref.location.nativeElement.id = componentType + elementId;
        ref.instance.data = info.title;
        ref.location.nativeElement.classList.add('col-lg-' + width);
        ref.instance.i = index;
        ref.changeDetectorRef.detectChanges();
        break;
      }

      case 'CustomForm': {
        const factory = this.componentFactoryResolver.resolveComponentFactory(FormContactoComponent);
        const ref = this.viewContainerRefA(index).createComponent(factory);
        if (elementId) ref.location.nativeElement.id = componentType + elementId;
        ref.location.nativeElement.classList.add('col-lg-' + width);
        ref.changeDetectorRef.detectChanges();
        break;
      }

      case 'Diary': {
        const factory = this.componentFactoryResolver.resolveComponentFactory(CustomDiaryGeneralComponent);
        const ref = this.viewContainerRefA(index).createComponent(factory);
        let calculatedWidth = (index === 2) ? 4 : width;
        if (elementId) ref.location.nativeElement.id = componentType + elementId;
        ref.location.nativeElement.classList.add('col-lg-' + calculatedWidth);
        ref.instance.data = info.diary[0].diaryItem;
        ref.instance.title = info.diary[0].title;
        ref.instance.width = calculatedWidth;
        ref.instance.botonTitle = "Eventos de la facultad";
        ref.changeDetectorRef.detectChanges();
        break;
      }

      case 'CustomStats': {
        const factory = this.componentFactoryResolver.resolveComponentFactory(CustomStatsGeneralComponent);
        const ref = this.viewContainerRefA(index).createComponent(factory);
        ref.location.nativeElement.classList.add('col-lg-' + width);
        if (elementId) ref.location.nativeElement.id = componentType + elementId;
        ref.instance.data = info.CustomStats;
        ref.instance.width = width;
        ref.changeDetectorRef.detectChanges();
        break;
      }

      case 'Cabecera': {
        const factory = this.componentFactoryResolver.resolveComponentFactory(CabeceraComponent);
        const ref = this.viewContainerRefA(index).createComponent(factory);
        ref.location.nativeElement.classList.add('col-lg-' + width);
        if (elementId) ref.location.nativeElement.id = componentType + elementId;
        ref.instance.title = info.entityList[0].title;
        ref.instance.slider = info.entityList[0].entity;
        ref.instance.background = info.entityList[0].background;
        ref.instance.path = info.entityList[0].path;
        ref.instance.width = width;
        ref.instance.noticesLinkTitle = info.entityList[0].noticesLinkTitle;
        ref.instance.noticesLink = info.entityList[0].noticesLink.systemTitle;
        ref.instance.cabeceraButtons = info.entityList[0].cabeceraButtons;
        ref.changeDetectorRef.detectChanges();
        break;
      }

     case 'Preguntas': {
        const factory = this.componentFactoryResolver.resolveComponentFactory(PreguntasFrecuentesFacultdadComponent);
        const ref = this.viewContainerRefA(index).createComponent(factory);
        ref.location.nativeElement.classList.add('col-lg-' + width);
        if (elementId) ref.location.nativeElement.id = componentType + elementId;
        ref.instance.data = info;
        ref.changeDetectorRef.detectChanges();
        break;
      }
    }
  }

  viewContainerRefA(index: number): any {
    switch (index) {
      case 1:
        return this.viewContainerRef1;
      case 2:
        return this.viewContainerRef2;
      case 3:
        return this.viewContainerRef3;
      case 4:
        return this.viewContainerRef4;
      case 5:
        return this.viewContainerRef5;
      case 6:
        return this.viewContainerRef6;
      case 7:
        return this.viewContainerRef7;
      case 8:
        return this.viewContainerRef8;
      case 9:
        return this.viewContainerRef9;
      case 10:
        return this.viewContainerRef10;
      case 11:
        return this.viewContainerRef11;
      case 12:
        return this.viewContainerRef12;
      case 13:
        return this.viewContainerRef13;
      case 14:
        return this.viewContainerRef14;
      case 15:
        return this.viewContainerRef15;
      case 16:
        return this.viewContainerRef16;
      case 17:
        return this.viewContainerRef17;
      case 18:
        return this.viewContainerRef18;
      case 19:
        return this.viewContainerRef19;
      case 20:
        return this.viewContainerRef20;
      default:
        // 
        break;
    }
  }
  url(element: any) {
    let url = '';
    if (element.route) {
      if (element.externalLink) {
        url = element.route;

      } else {
        url = element.route
        if (element.route[0] == '/') {
          url = element.route = element.route.replace('/', '')
        }
        url = '/' + this.language + '/' + url;
      }

    }
    if (element.systemTitle) {
      url = element.systemTitle
      if (element.externalLink) {
        url = element.systemTitle;

      } else {
        if (element.systemTitle[0] == '/') {
          url = element.systemTitle = element.systemTitle.replace('/', '')
        }
        url = '/' + this.language + '/' + url;
      }
    }

    return url;
  }

}
